import Form from './form'

$.fn.BuilderForm = function(form_options) {
  let self = this

  self.initialize_form = function() {
    new Form(self.get(0), form_options)
  }

  return function() {
    self.initialize_form(form_options)
    return self
  }()
}

export function Form_CoreInit(custom_parameters = []) {
  $('.builder-form').each(function() {
    let self = $(this)

    let formOptions = {
      onSubmit: function() {
        self.addClass('builder-form--blocked')
      },
      onSuccess: function() {
        //
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('builder-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    }

    if (self.find('.form-steps').length) {
      formOptions.steps = {
        use_steps: true,
        submit_steps: true,
      }
      formOptions.onStep = function() {
        requestAnimationFrame(function() {
          self.removeClass('builder-form--blocked')
        })
      }
    }

    custom_parameters.forEach(function(item) {
      if (self.hasClass(item.classSelector)) {
        formOptions = $.extend(true, formOptions, item.formOptions)
      }
    })

    self.BuilderForm(formOptions)
  })
}
